import useAppService from './useAppService.js';

function useApi() {
    const app = useAppService();
    return app.api;
}

export { useApi as default };
//# sourceMappingURL=useApi.js.map
